"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseTypes = void 0;
/*
 * @Author: your name
 * @Date: 2022-02-22 13:35:05
 * @LastEditTime: 2022-02-22 13:50:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\use\index.ts
 */
var ProgressBar_1 = require("./ProgressBar");
exports.UseTypes = { ProgressBar: ProgressBar_1.ProgressBar };
//# sourceMappingURL=index.js.map